<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" @submit="submit" modalClass="modal-md">
        <template #title>
            {{ i18n('Edit profiles') + (application.name ? ' ' + application.name : '') }}
        </template>
        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <EmptyListItem v-if="loading" :loading="loading" />

        <table class="table" v-if="!loading && profiles.length > 0">
            <caption class="sr-only" data-no-export>{{ i18n('Edit profiles') }}</caption>
            <tbody>
                <tr>
                    <th>{{ i18n('Profile name') }}</th>
                    <th></th>
                </tr>
                <tr v-for="profile in profiles" :key="profile.id">
                    <td>{{ profile.name }}</td>
                    <td>
                        <input type="checkbox" :value="profile.id" v-model="userProfilesByProfile[profile.id]" />
                    </td>
                </tr>
            </tbody>
        </table>

        <template #footer>
            <div class="row">
                <div class="col text-end">
                    <button type="submit" class="btn btn-dark btn-sm" :disabled="submitted">
                        {{ i18n('Confirm') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>
<script>
import api from "@/api.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import EmptyListItem from "../common/list/EmptyListItem.vue";

export default {
    components: {
        Modal,
        Field,
        EmptyListItem,
    },
    data() {
        return {
            submitted: false,
            errorMessages: {},
            errorMessage: '',
            application_id: null,
            application: {},
            user: {},
            userProfiles: [],
            profiles: [],
            userProfilesByProfile: [],
            loading: false,
        };
    },
    props: {},
    emits: [
        'shown',
        'hidden',
        'submit',
        'updated',
        'setExpirations',
    ],
    mounted() {},
    methods: {
        load() {
            api.get('applications/' + this.application_id, {})
                .then(application => {
                    this.application = application;

                    api.get('applications/' + this.application.id + '/profiles', {'restricted': true})
                        .then(profiles => {
                            this.profiles = profiles;

                            api.get('users/' + this.user.id + '/profiles', {})
                                .then(userProfiles => {
                                    this.userProfiles = userProfiles;
                                    this.profiles.forEach(profile => {
                                        this.userProfilesByProfile[profile.id] = false;

                                        this.userProfiles.forEach(p => {
                                            if (profile.id == p.id) {
                                                this.userProfilesByProfile[profile.id] = true;
                                            }
                                        });
                                    });

                                    this.loading = false;
                                });
                        });
                });

        },
        show(user, application_id) {
            this.user = user;
            this.application_id = application_id;
            this.submitted = false;
            this.userProfiles = [];
            this.errorMessage = '';
            this.application = {};
            this.profiles = [];
            this.userProfilesByProfile = [];
            this.loading = true;

            this.load();
            this.$refs['modal'].show();
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            let deleteProfiles = [],
                addProfiles = [];

            this.profiles.forEach(profile => {
                if (this.userProfilesByProfile[profile.id] && !this.userProfiles.some(p => p.id === profile.id)) {
                    addProfiles.push(profile);
                } else if (!this.userProfilesByProfile[profile.id] && this.userProfiles.some(p => p.id === profile.id)) {
                    deleteProfiles.push(profile);
                }
            });

            if (this.application.is_single_profile
                && Object.values(this.userProfilesByProfile).filter(value => value).length > 1) {
                this.errorMessage = this.i18n('You can only have one profile for this application');
                return;
            }

            this.$emit('setExpirations', { user: this.user, application: this.application, deleteProfiles: deleteProfiles, addProfiles: addProfiles });
            this.hide();
        },
    }
};
</script>